module.exports = __webpack_public_path__ + "static/club_min-27636c80f522593ed318d140de3cd7e8.jpg";